import { signupApi } from './signup'

import { FeatureFlagsResponse } from 'types'

const featureFlagsApi = signupApi.injectEndpoints({
  endpoints: (builder) => ({
    featureFlags: builder.query<FeatureFlagsResponse, { userKey: string; flags: string[] }>({
      query: ({ userKey, flags }) => ({
        url: `flags?userKey=${userKey}&name=${flags.join(',')}`,
        method: 'GET',
      }),
      providesTags: (result, error, { userKey, flags }) => [
        { type: 'Flags', id: `${userKey}_${flags.join(',')}` },
      ],
    }),
  }),
})

const { useFeatureFlagsQuery, useLazyFeatureFlagsQuery } = featureFlagsApi

export { featureFlagsApi, useFeatureFlagsQuery, useLazyFeatureFlagsQuery }
